import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  TextField,
  Select,
  MenuItem,
  Chip,
  InputLabel,
  Input,
  OutlinedInput,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import * as validator from 'email-validator';
import { AdminPortalTextField } from '../ConsumerAccountProperties';
import { Popover } from 'react-fast-ui';

import AdminPortalModal from '../AdminPortalModal';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const ROLES_STYLE = {
  width: '30%',
  marginTop: 10,
  marginRight: '3%',
  marginBottom: 5,
};
const PRODUCTS = [
  { id: 512, name: 'FastScout', show: false },
  { id: 16, name: 'FastRecruit', show: false },
  { id: 1024, name: 'FastAccess', show: false },
  { id: 1, name: 'FastDraw', show: false },
  { id: 8, name: 'FastDrawTablet', show: false },
  { id: 2, name: 'FastScout Classic', show: false },
  { id: 2048, name: 'FastDraw2', show: false },
  { id: 4096, name: 'FastDrawTablet2', show: false },
];

const EMPTY_STATE = {
  licensedProductIds: [],
  readyToFinish: false,
  products: PRODUCTS,
  emailError: false,
  passwordError: false,
  confirmPasswordError: false,
  firstNameError: false,
  lastNameError: false,
  scoutClassicSeatError: false,
  drawTabletSeatError: false,
  drawSeatError: false,
  recruitSeatError: false,
  removePassword: false,
  user: {
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    email: '',
    productRoles: [],
  },
  isLongEnough: false,
  hasUpperCase: false,
  hasLowerCase: false,
  hasDigit: false,
  hasSpecialCharacter: false,
  isValid: true,
};

class AddAccountUserModal extends Component {
  static propTypes = {
    accountUser: PropTypes.object,
    isEditing: PropTypes.bool,
  };

  defaultProps = {
    isEditing: false,
  };

  state = {
    ...EMPTY_STATE,
  };

  componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any) {
    const { accountUser, licensedProducts } = this.props;
    if (accountUser !== nextProps.accountUser) {
      const ids = _.pluck(nextProps.accountUser.productRoles, 'product').filter(
        (key) => PRODUCTS.find((product) => product.id === key)
      );
      const selectedProducts = ids.reduce((products, id) => {
        const filteredProduct = licensedProducts.find(
          (license) => license.product.id === id
        );
        if (filteredProduct) {
          products.push({
            id: filteredProduct.product.id,
            name:
              filteredProduct.product.displayName ||
              filteredProduct.product.name,
            show: true,
          });
        }
        return products;
      }, []);
      const products = PRODUCTS.map((product) => {
        const updatedProduct = selectedProducts.find(
          (item) => item.id === product.id
        );
        return updatedProduct || product;
      });
      this.setState({
        licensedProductIds: ids,
        products,
        user: {
          ...EMPTY_STATE.user,
          ...nextProps.accountUser,
        },
      });
    }
  }

  handleFinish = () => {
    const { onSave, isEditing } = this.props;
    onSave(this.state.user, isEditing);
    this.onClose();
  };

  handleRequiredFields = (e) => {
    if (e.target.value === '') {
      this.setState({
        [ `${e.target.id}Error` ]: true,
        user: { ...this.state.user, [ e.target.id ]: '' },
      });
    } else {
      this.setState({
        [ `${e.target.id}Error` ]: false,
        user: { ...this.state.user, [ e.target.id ]: e.target.value },
      });
    }
  };

  handleConfirmPasswordField = (e) => {
    const {
      user: { password },
    } = this.state;
    if (e.target.value === '' || e.target.value !== password) {
      this.setState({
        confirmPasswordError: true,
        user: { ...this.state.user, confirmPassword: '' },
      });
    } else {
      this.setState({
        confirmPasswordError: false,
        user: { ...this.state.user, confirmPassword: e.target.value },
      });
    }
  };

  handlePasswordField = (e) => {
    const {
      user: { confirmPassword },
      confirmPasswordError,
    } = this.state;
    let passwordState;
    if (e.target.value === '') {
      passwordState = {
        passwordError: true,
        user: { ...this.state.user, password: '' },
      };
    } else {
      passwordState = {
        passwordError: false,
        user: { ...this.state.user, password: e.target.value },
      };
    }

    if (confirmPassword === null || confirmPassword === '') {
      passwordState = {
        passwordError: passwordState.passwordError,
        confirmPasswordError: true,
        user: { ...passwordState.user, confirmPassword: '' },
      };
    } else {
      passwordState = {
        passwordError: passwordState.passwordError,
        confirmPasswordError,
        user: { ...passwordState.user, confirmPassword },
      };
    }
    this.setState(passwordState);
  };

  handleEmailField = (e) => {
    const isValidEmail = validator.validate(e.target.value);
    if (e.target.value === '' || !isValidEmail) {
      this.setState({
        emailError: true,
        user: { ...this.state.user, [ e.target.id ]: e.target.value },
      });
    } else {
      this.setState({
        emailError: false,
        user: { ...this.state.user, [ e.target.id ]: e.target.value },
      });
    }
  };

  handleSelectedProducts = (e) => {
    const { licensedProducts } = this.props;
    const {
      user: { productRoles },
    } = this.state;
    const selectedProducts = e.target.value.reduce((products, id) => {
      const filteredProduct = licensedProducts.find(
        (license) => license.product.id === id
      );
      if (filteredProduct) {
        products.push({
          id: filteredProduct.product.id,
          name:
            filteredProduct.product.displayName || filteredProduct.product.name,
          show: true,
        });
      }
      return products;
    }, []);

    let selectedUserProducts = _.map(e.target.value, (id) => {
      return _.filter(productRoles, (role) => role.product === id)[ 0 ] || false;
    }).filter(Boolean);

    // Automatically assign a seat to Draw2/TabletDraw2 if selected.
    if (selectedProducts.find((p) => [ 2048, 4096 ].includes(p.id))) {
      let webAndiPadProducts = selectedProducts
        .filter((p) => [ 2048, 4096 ].includes(p.id))
        .map((p) => ({ product: p.id, seatActivations: 1 }));

      selectedUserProducts.push(...webAndiPadProducts);
      selectedUserProducts = _.uniq(selectedUserProducts, (p) => p.product);
    }

    this.setState({
      licensedProductIds: e.target.value,
      products: PRODUCTS.map((product) => {
        const updatedProduct = selectedProducts.find(
          (item) => item.id === product.id
        );
        return updatedProduct || product;
      }),
      user: {
        ...this.state.user,
        productRoles: selectedUserProducts,
      },
    });
  };

  handleSelectedScoutRole = (e) => {
    const product = this.state.products.find(
      (product) => product.name === 'FastScout'
    );
    this.handleSelectedRole(product.id, e.target.value);
  };

  handleSelectedAccessRole = (e) => {
    const product = this.state.products.find(
      (product) => product.name === 'FastAccess'
    );
    this.handleSelectedRole(product.id, e.target.value);
  };

  handleSelectedDrawSeat = (e) => {
    const product = this.state.products.find(
      (product) => product.name === 'FastDraw'
    );
    this.handleInputtedSeats(product.id, e);
  };

  handleSelectedDrawTableSeat = (e) => {
    const product = this.state.products.find(
      (product) => product.name === 'FastDrawTablet'
    );
    this.handleInputtedSeats(product.id, e);
  };

  handleSelectedScoutClassicSeat = (e) => {
    const product = this.state.products.find(
      (product) => product.name === 'FastScout Classic'
    );
    this.handleInputtedSeats(product.id, e);
  };

  handleSelectedFastRecruitSeat = (e) => {
    const product = this.state.products.find(
      (product) => product.name === 'FastRecruit'
    );
    this.handleRecruitInputtedSeats(product.id, e);
  };

  handleRecruitInputtedSeats(id, e) {
    if (e.target.value === '') {
      this.setState({ recruitSeatError: true });
    } else {
      this.handleInputtedSeats(id, e);
    }
  }

  handleInputtedSeats(id, e) {
    const { licensedProducts } = this.props;
    const {
      user: { productRoles },
    } = this.state;
    const selectedRoles = { product: id, seatActivations: e.target.value };
    const products = productRoles.filter((product) => product.product === id);
    const licensedProduct = licensedProducts.find(
      (item) => item.product.id === id
    );
    const seatsAvailable = licensedProduct.quantity - licensedProduct.allocated;

    const currentlyAlloted = this.props.accountUser
      ? parseInt(this.findSeatValue(id, this.props.accountUser))
      : 0;
    if (products.length === 0) {
      this.setState({
        [ `${e.target.id}Error` ]: e.target.value > seatsAvailable,
        user: {
          ...this.state.user,
          productRoles: [ ...this.state.user.productRoles, selectedRoles ],
        },
      });
    } else {
      const updatedProductRoles = this.updateSeatStateArray(id, e.target.value);
      this.setState({
        [ `${e.target.id}Error` ]:
          e.target.value > seatsAvailable + currentlyAlloted,
        user: { ...this.state.user, productRoles: updatedProductRoles },
      });
    }
  }

  updateSeatStateArray(product, value) {
    const {
      user: { productRoles },
    } = this.state;
    return productRoles.map((role) => {
      return role.product === product
        ? { product, seatActivations: value }
        : role;
    });
  }

  handleSelectedRole(id, value) {
    const {
      user: { productRoles },
    } = this.state;
    const selectedRoles = { product: id, roles: value };
    const products = productRoles.filter((role) => role.product === id);
    if (products.length === 0) {
      this.setState({
        user: {
          ...this.state.user,
          productRoles: [ ...this.state.user.productRoles, selectedRoles ],
        },
      });
    } else {
      const updatedProductRoles = this.updateRoleStateArray(id, value);
      this.setState({
        user: { ...this.state.user, productRoles: updatedProductRoles },
      });
    }
  }

  updateRoleStateArray(product, value) {
    const {
      user: { productRoles },
    } = this.state;
    return productRoles.map((role) => {
      return role.product === product ? { product, roles: value } : role;
    });
  }

  findRoleValue(productId) {
    const {
      user: { productRoles },
    } = this.state;
    const productRole = productRoles.filter(
      (role) => role.product === productId
    );
    return productRole && productRole.length !== 0 ? productRole[ 0 ].roles : [];
  }

  findSeatValue(productId, user) {
    const { productRoles } = user;
    const productRole = productRoles.filter(
      (role) => role.product === productId
    );
    return productRole && productRole.length !== 0
      ? productRole[ 0 ].seatActivations
      : '';
  }

  handleReadyToFinish() {
    const isSeatReady = this.seatCheck();
    const isRoleReady = this.roleCheck();
    const isUserFieldsReady = this.userFieldsCheck();
    return (
      isUserFieldsReady && isRoleReady && isSeatReady && this.state.isValid
    );
  }

  seatCheck() {
    const { user, products } = this.state;
    let isSeatReady = true;
    const productSeats = products.filter(
      (product) =>
        product.name === 'FastRecruit' ||
        product.name === 'FastScout Classic' ||
        product.name === 'FastDrawTablet' ||
        product.name === 'FastDraw'
    );
    _.map(productSeats, (product) => {
      if (product.show) {
        const seat = user.productRoles.find(
          (seat) => seat.product === product.id
        );
        if (seat === undefined || seat.seatActivations === '') {
          isSeatReady = false;
        }
      }
    });
    return isSeatReady;
  }

  roleCheck() {
    const { user, products } = this.state;
    let isRoleReady = true;
    const productSeats = products.filter(
      (product) => product.name === 'FastScout' || product.name === 'FastAccess'
    );
    _.map(productSeats, (productSeat) => {
      if (productSeat.show) {
        const role = user.productRoles.find(
          (role) => role.product === productSeat.id
        );
        if (!(role && role.roles.length > 0)) {
          isRoleReady = false;
        }
      }
    });
    return isRoleReady;
  }

  userFieldsCheck() {
    const { isEditing } = this.props;
    const { user } = this.state;
    let isUserFieldsReady = true;
    Object.keys(user).forEach((key) => {
      if (user[ key ] === '') {
        isUserFieldsReady = false;
      }
      if (isEditing && (key === 'password' || key === 'confirmPassword')) {
        if (user.password === '' && user.confirmPassword === '') {
          isUserFieldsReady = true;
        }
      }
    });
    return isUserFieldsReady;
  }

  showScoutRoleError() {
    const { user, products } = this.state;
    const productScoutSeat = products.find(
      (product) => product.name === 'FastScout'
    );
    const role = user.productRoles.find(
      (roles) => roles.product === productScoutSeat.id
    );
    return !(role && role.roles.length > 0);
  }

  showAccessRoleError() {
    const { user, products } = this.state;
    const productAccessSeat = products.find(
      (product) => product.name === 'FastAccess'
    );
    const role = user.productRoles.find(
      (roles) => roles.product === productAccessSeat.id
    );
    return !(role && role.roles.length > 0);
  }

  generateLicensedProductName(licensedProduct) {
    if (licensedProduct) {
      return `${
        licensedProduct.product.displayName || licensedProduct.product.name
      } 
      (${
        licensedProduct.quantity - licensedProduct.allocated
      } seats remaining)`;
    }
  }

  findLicensedProductName(value) {
    const { licensedProducts } = this.props;
    const licensedProduct = licensedProducts.find(
      (license) => license.product.id === value
    );
    return this.generateLicensedProductName(licensedProduct);
  }

  findRoleName(value) {
    const { accessRoles, scoutRoles } = this.props;
    const roles = scoutRoles.concat(accessRoles);
    const role = roles.find((role) => role.id === value);
    return role.name;
  }

  selectedProductChips = (selected) => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {selected.map((value) => {
        const name = this.findLicensedProductName(value);
        return (
          <Chip
            key={value}
            label={name}
            style={{ marginLeft: 2, marginRight: 2, marginTop: 10 }}
          />
        );
      })}
    </div>
  );

  selectedRoleChips = (selected) => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {selected.map((value) => {
        const name = this.findRoleName(value);
        return (
          <Chip
            key={value}
            label={name}
            style={{ marginLeft: 2, marginRight: 2, marginTop: 10 }}
          />
        );
      })}
    </div>
  );

  onClose = () => {
    const { onClose } = this.props;
    this.setState({ ...EMPTY_STATE });
    onClose();
  };

  handleCheckPassword = (event) => {
    const { value } = event.target;

    const isLongEnough = value.length >= 8;
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasDigit = /\d/.test(value);
    const hasSpecialCharacter = /[!@#$%^&*]/.test(value);

    const isValid =
      isLongEnough &&
      hasUpperCase &&
      hasLowerCase &&
      hasDigit &&
      hasSpecialCharacter;

    this.setState({
      isLongEnough,
      hasUpperCase,
      hasLowerCase,
      hasDigit,
      hasSpecialCharacter,
      isValid,
    });
  };

  render() {
    const {
      open,
      accentColor,
      isEditing,
      licensedProducts,
      accessRoles,
      featureFlags,
    } = this.props;
    const {
      licensedProductIds,
      products,
      user: { email, password, firstName, lastName, confirmPassword },
      isLongEnough,
      hasUpperCase,
      hasLowerCase,
      hasDigit,
      hasSpecialCharacter,
      isValid,
    } = this.state;
    let scoutRoles = this.props.scoutRoles.filter((role) => {
      if (
        role.name === 'Scout' &&
        !(featureFlags || []).includes('player_scout')
      ) {
        return false;
      }
      return true;
    });
    const readyToFinish = this.handleReadyToFinish();
    const theme = createMuiTheme({
      palette: {
        primary: { 500: accentColor },
      },
      typography: { fontFamily: 'Barlow, sans-serif' },
    });
    const productAccessSeat = products.find(
      (product) => product.name === 'FastAccess'
    );
    const productScoutSeat = products.find(
      (product) => product.name === 'FastScout'
    );
    const productRecruitSeat = products.find(
      (product) => product.name === 'FastRecruit'
    );
    const productDrawSeat = products.find(
      (product) => product.name === 'FastDraw'
    );
    const productScoutClassicSeat = products.find(
      (product) => product.name === 'FastScout Classic'
    );
    const productDrawTabletSeat = products.find(
      (product) => product.name === 'FastDrawTablet'
    );

    return (
      <AdminPortalModal
        open={open}
        onClose={this.onClose}
        accentColor={accentColor}
        size="lg"
        style={{ zIndex: 80 }}
        title={isEditing ? 'UPDATE ACCOUNT USER' : 'NEW ACCOUNT USER'}
        finishVerb="SAVE"
        finishButtonID="addUserButton"
        canSave={readyToFinish}
        onSave={this.handleFinish}
      >
        <ThemeProvider theme={theme}>
          <div style={{ paddingBottom: 10 }}>
            <div
              className="display-flex full-width"
              style={{ paddingTop: 10, marginRight: 20 }}
            >
              <AdminPortalTextField
                error={this.state.emailError}
                id="email"
                label="Email"
                defaultValue={email || ''}
                helperText={
                  isEditing
                    ? ''
                    : 'Enter the email of the user to add to the account.'
                }
                variant="outlined"
                onBlur={this.handleEmailField}
                color="primary"
                name="email"
                InputLabelProps={{ shrink: true }}
                disabled={isEditing}
                fullWidth
                required
              />
            </div>
            <div
              className="display-flex full-width"
              style={{ marginTop: '15px', marginRight: 20 }}
            >
              <div className="display-flex flex-direction-column width-50-percent mg-right-md justify-content-space-between">
                <TextField
                  error={this.state.firstNameError}
                  id="firstName"
                  label="First Name"
                  defaultValue={firstName || ''}
                  helperText="Enter the first name of the user to add to the account."
                  variant="outlined"
                  onBlur={this.handleRequiredFields}
                  color="primary"
                  fullWidth
                  required
                />
                <TextField
                  style={{ marginTop: '15px' }}
                  error={this.state.lastNameError}
                  id="lastName"
                  label="Last Name"
                  defaultValue={lastName || ''}
                  helperText="Enter the last name of the user to add to the account."
                  variant="outlined"
                  onBlur={this.handleRequiredFields}
                  color="primary"
                  fullWidth
                  required
                />
              </div>
              {isEditing ? (
                <div className="display-flex flex-direction-column width-50-percent mg-left-md">
                  <h2
                    style={{
                      fontSize: 18,
                      border: '1px solid black',
                      borderWidth: '0 0 1px 0',
                      paddingBottom: 4,
                      marginBottom: 10,
                    }}
                    className="futura-pt-bold"
                  >
                    Password
                  </h2>
                  <div>
                    Passwords can be reset by email with the user's email
                    address.
                    <br /> <br /> Navigate to the login screen, click the
                    "Forgot Password" link at the bottom, and follow the prompts
                    to send a secure password reset link by email.
                  </div>
                </div>
              ) : (
                <div className="display-flex flex-direction-column width-50-percent mg-left-md justify-content-space-between">
                  <FormControl>
                    <InputLabel
                      className="MuiInputLabel-outlined"
                      htmlFor="password"
                    >
                      Password
                    </InputLabel>
                    <OutlinedInput
                      error={this.state.passwordError}
                      id="password"
                      label="Password"
                      defaultValue={password || ''}
                      variant="outlined"
                      onBlur={this.handlePasswordField}
                      onChange={this.handleCheckPassword}
                      color="primary"
                      type="password"
                      fullWidth
                      required
                    />
                    <FormHelperText>
                      <span>
                        <Popover
                          open={this.state.passwordHint}
                          content={
                            <div
                              style={{
                                padding: 20,
                                backgroundColor: '#fff',
                                border: '2px solid #CCC',
                              }}
                            >
                              Minimum Passwords Requirements:
                              <br />
                              <ul style={{ paddingLeft: 20 }}>
                                <li
                                  style={{
                                    color: isLongEnough ? 'green' : 'red',
                                  }}
                                >
                                  8+ characters long
                                </li>
                                <li
                                  style={{
                                    color: hasUpperCase ? 'green' : 'red',
                                  }}
                                >
                                  1 upper case character
                                </li>
                                <li
                                  style={{
                                    color: hasLowerCase ? 'green' : 'red',
                                  }}
                                >
                                  1 lower case character
                                </li>
                                <li
                                  style={{
                                    color: hasDigit ? 'green' : 'red',
                                  }}
                                >
                                  1 digit (0-9)
                                </li>
                                <li
                                  style={{
                                    color: hasSpecialCharacter
                                      ? 'green'
                                      : 'red',
                                  }}
                                >
                                  1 special character (!@#$%^&*)
                                </li>
                              </ul>
                            </div>
                          }
                        >
                          <span
                            style={{
                              display: 'inline-block',
                              cursor: 'help',
                              color: this.state.isValid ? 'green' : 'red',
                              textDecoration: 'underline',
                            }}
                            onMouseEnter={() =>
                              this.setState({ passwordHint: true })
                            }
                            onMouseLeave={() =>
                              this.setState({ passwordHint: false })
                            }
                          >
                            Minimum Requirements
                          </span>
                        </Popover>
                        &nbsp;&nbsp;Enter the password you would like to assign
                        to the user.<br />If this Hudl user already exists, this password will not apply.
                      </span>
                    </FormHelperText>
                  </FormControl>
                  <TextField
                    style={{ marginTop: '15px' }}
                    error={this.state.confirmPasswordError}
                    id="confirmPassword"
                    label="Confirm Password"
                    defaultValue={confirmPassword || ''}
                    helperText="Passwords must match"
                    variant="outlined"
                    type="password"
                    onBlur={this.handleConfirmPasswordField}
                    color="primary"
                    fullWidth
                    required
                  />
                </div>
              )}
            </div>
            <div className="display-flex full-width" style={{ paddingTop: 10 }}>
              <FormControl variant="filled" style={{ width: '100%' }}>
                <InputLabel margin="dense">Product Seats</InputLabel>
                <Select
                  multiple
                  id="productSeat"
                  value={licensedProductIds}
                  onChange={this.handleSelectedProducts}
                  input={<OutlinedInput id="select-multiple-chip" />}
                  renderValue={this.selectedProductChips}
                  MenuProps={MenuProps}
                >
                  {licensedProducts.map((licensedProduct) => {
                    const name =
                      this.generateLicensedProductName(licensedProduct);
                    return (
                      <MenuItem key={name} value={licensedProduct.product.id}>
                        {name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="full-width">
              {(productScoutSeat.show || productAccessSeat.show) && (
                <div
                  className="full-width flex-wrap-nowrap"
                  style={{ marginTop: 15 }}
                >
                  <div
                    className="full-width"
                    style={{
                      borderBottom: `1px solid ${accentColor}`,
                      paddingBottom: 4,
                      marginBottom: 4,
                    }}
                  >
                    <h2 style={{ fontSize: 18 }} className="futura-pt-bold">
                      Roles
                    </h2>
                  </div>
                  {productScoutSeat.show && (
                    <FormControl variant="filled" style={ROLES_STYLE}>
                      <InputLabel margin="dense">Scout Role *</InputLabel>
                      <Select
                        multiple
                        id="scoutRole"
                        value={this.findRoleValue(productScoutSeat.id)}
                        onChange={this.handleSelectedScoutRole}
                        input={
                          <OutlinedInput id="select-multiple-scout-chip" />
                        }
                        renderValue={this.selectedRoleChips}
                        MenuProps={MenuProps}
                      >
                        {scoutRoles.map((role) => {
                          return (
                            <MenuItem key={role.name} value={role.id}>
                              {role.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {this.showScoutRoleError() && (
                        <FormHelperText error={productScoutSeat.show}>
                          This is a required field!
                        </FormHelperText>
                      )}
                    </FormControl>
                  )}
                  {productAccessSeat.show && (
                    <FormControl variant="filled" style={ROLES_STYLE}>
                      <InputLabel margin="dense">Access Role *</InputLabel>
                      <Select
                        multiple
                        id="accessRole"
                        value={this.findRoleValue(productAccessSeat.id)}
                        onChange={this.handleSelectedAccessRole}
                        input={
                          <OutlinedInput id="select-multiple-access-chip" />
                        }
                        renderValue={this.selectedRoleChips}
                        MenuProps={MenuProps}
                      >
                        {accessRoles.map((role) => {
                          return (
                            <MenuItem key={role.name} value={role.id}>
                              {role.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {this.showAccessRoleError() && (
                        <FormHelperText error={productAccessSeat.show}>
                          This is a required field!
                        </FormHelperText>
                      )}
                    </FormControl>
                  )}
                </div>
              )}
            </div>
            <div className="full-width">
              {(productScoutClassicSeat.show ||
                productDrawSeat.show ||
                productDrawTabletSeat.show ||
                productRecruitSeat.show) && (
                <div className="full-width" style={{ marginTop: 15 }}>
                  <div
                    className="full-width"
                    style={{
                      borderBottom: `1px solid ${accentColor}`,
                      paddingBottom: 4,
                      marginBottom: 4,
                    }}
                  >
                    <h2 style={{ fontSize: 18 }} className="futura-pt-bold">
                      Seat Activations
                    </h2>
                  </div>
                  <div className="full-width display-flex flex-wrap-nowrap">
                    {productRecruitSeat.show && (
                      <div style={ROLES_STYLE}>
                        <TextField
                          error={this.state.recruitSeatError}
                          inputRef={{ className: 'digitsOnly' }}
                          id="recruitSeat"
                          type={'number'}
                          label="FastRecruit Seat(s)"
                          defaultValue={this.findSeatValue(
                            productRecruitSeat.id,
                            this.state.user
                          )}
                          helperText={
                            this.state.recruitSeatError
                              ? 'Invalid number of seats'
                              : 'Enter the number of seats to assign to the user'
                          }
                          variant="outlined"
                          onBlur={this.handleSelectedFastRecruitSeat}
                          color="primary"
                          fullWidth
                          required
                        />
                      </div>
                    )}
                    {productScoutClassicSeat.show && (
                      <div style={ROLES_STYLE}>
                        <TextField
                          error={this.state.scoutClassicSeatError}
                          inputRef={{ className: 'digitsOnly' }}
                          id="scoutClassicSeat"
                          type={'number'}
                          label="FastScout Classic Seat(s)"
                          defaultValue={this.findSeatValue(
                            productScoutClassicSeat.id,
                            this.state.user
                          )}
                          helperText={
                            this.state.scoutClassicSeatError
                              ? 'Invalid number of seats'
                              : 'Enter the number of seats to assign to the user'
                          }
                          variant="outlined"
                          onBlur={this.handleSelectedScoutClassicSeat}
                          color="primary"
                          fullWidth
                          required
                        />
                      </div>
                    )}
                    {productDrawSeat.show && (
                      <div style={ROLES_STYLE}>
                        <TextField
                          error={this.state.drawSeatError}
                          inputRef={{ className: 'digitsOnly' }}
                          id="drawSeat"
                          type={'number'}
                          label="FastDraw Seat(s)"
                          defaultValue={this.findSeatValue(
                            productDrawSeat.id,
                            this.state.user
                          )}
                          helperText={
                            this.state.drawSeatError
                              ? 'Invalid number of seats'
                              : 'Enter the number of seats to assign to the user'
                          }
                          variant="outlined"
                          onBlur={this.handleSelectedDrawSeat}
                          color="primary"
                          fullWidth
                          required
                        />
                      </div>
                    )}
                    {productDrawTabletSeat.show && (
                      <div style={ROLES_STYLE}>
                        <TextField
                          error={this.state.drawTabletSeatError}
                          inputRef={{ className: 'digitsOnly' }}
                          id="drawTabletSeat"
                          type={'number'}
                          label="FastDraw Tablet Seat(s)"
                          defaultValue={this.findSeatValue(
                            productDrawTabletSeat.id,
                            this.state.user
                          )}
                          helperText={
                            this.state.drawTabletSeatError
                              ? 'Invalid number of seats'
                              : 'Enter the number of seats to assign to the user'
                          }
                          variant="outlined"
                          onBlur={this.handleSelectedDrawTableSeat}
                          color="primary"
                          fullWidth
                          required
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </ThemeProvider>
      </AdminPortalModal>
    );
  }
}

export default connect()(AddAccountUserModal);
